module.exports = __webpack_public_path__ + "img/product-preview-53.feb4f6d.png";